<script setup lang="ts">
    import type { ProductSummaryData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';
    import type { PageProductSummaryFragment } from '~/graphql/generated';
    const props = defineProps<IWidgetProps<ProductSummaryData>>();

    const { queryParams } = usePreview();

    const { data: requestData } = useAsyncData<PageProductSummaryFragment>(`product-summary:${props.data.product_page}`, () =>
        $fetch('/api/product-summary', {
            query: {
                id: props.data.product_page,
                ...queryParams.value,
            },
        }),
    );

    const { apiProduct, title, description, baseUrl } = useProductSummary(requestData);
</script>
<template>
    <!-- Empty div fixes the hydration issue -->
    <org-product-summary
        v-if="apiProduct"
        :product="apiProduct"
        :color-option-index="data.color_option"
        :title="title"
        :description="description"
        :base-url="baseUrl" />
    <div v-else></div>
</template>
